@if (loadingRouteConfig() || !authService.loaded()) {
  <div class="page-loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
} @else if (!authService.tenantMatches()){
  <div class="unauthorised-card">
    <p>Access Denied. User unauthorised.</p>
  </div>
} @else {
    <router-outlet/>
}
